/**
 * MGP Access Control System
 * Blocks specific collections and products based on handle prefixes.
 */
(function() {
  const HIDDEN_HANDLES = [
    "muc-off",
    "ycfusa-com",
    "onegripper-com",
    "mthelmets-com",
    "circuitequipment-us",
    "pmt-tyres-it"
  ];

  const PASSWORD_SECRET = "mgp2026"; 
  const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes in ms

  function isAccessAllowed() {
    const sessionStr = localStorage.getItem('mgp_access_session');
    if (!sessionStr) return false;

    try {
      const session = JSON.parse(sessionStr);
      const now = new Date().getTime();
      
      if (now - session.timestamp < SESSION_DURATION) {
        return true;
      } else {
        localStorage.removeItem('mgp_access_session');
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  function checkAccess() {
    const path = window.location.pathname;
    let isRestricted = false;
    let currentHandle = "";

    if (path.includes('/collections/')) {
      currentHandle = path.split('/collections/')[1].split('/')[0].split('?')[0];
      if (HIDDEN_HANDLES.includes(currentHandle)) {
        isRestricted = true;
      }
    } else if (path.includes('/products/')) {
      currentHandle = path.split('/products/')[1].split('?')[0];
      isRestricted = HIDDEN_HANDLES.some(prefix => currentHandle.startsWith(prefix));
    } else if (path.includes('/pages/')) {
      currentHandle = path.split('/pages/')[1].split('?')[0];
      isRestricted = HIDDEN_HANDLES.some(prefix => currentHandle.startsWith(prefix));
    }

    if (isRestricted && !isAccessAllowed()) {
      showLoginScreen();
    } else {
      document.documentElement.classList.remove('mgp-restricted-loading');
      if (isRestricted && isAccessAllowed() && path.includes('/collections/')) {
        applyLayoutChanges();
      }
    }
  }

  function applyLayoutChanges() {
    const sidebar = document.querySelector('aside#shopify-section-collection-sidebar');
    if (sidebar) {
      sidebar.classList.add('none');
      sidebar.style.display = 'none'; // Fallback to ensure it's hidden
    }

    const grid = document.querySelector('.layout-grid');
    if (grid) {
      grid.classList.remove('layout-grid--left-sidebar', 'd-grid');
    }
  }

  function showLoginScreen() {
    document.documentElement.classList.add('mgp-restricted-loading');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Remove existing if any
    const existing = document.getElementById('mgp-access-gateway');
    if (existing) existing.remove();

    const modal = document.createElement('div');
    modal.id = 'mgp-access-gateway';
    modal.style.cssText = `
      position: fixed;
      top: 0; left: 0; width: 100vw; height: 100vh;
      background: #fff;
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    `;

    modal.innerHTML = `
      <div style="background: #fff; padding: 3rem; border-radius: 0; border: 1px solid #eee; max-width: 500px; width: 100%; text-align: center; box-shadow: 0 10px 40px rgba(0,0,0,0.05);">
         <img src="https://www.mgpperformance.com/cdn/shop/files/LOGO_MGP_NEGRO.png?v=1718593640&width=300" alt="MGP" style="max-width: 180px; margin-bottom: 3rem;">
        
        <div style="margin-bottom: 2.5rem;">
          <h1 style="font-size: 1.2rem; margin-bottom: 0.5rem; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; color: #000;">Contenido Restringido</h1>
          <div style="width: 40px; height: 2px; background: #e10600; margin: 0 auto 1.5rem;"></div>
        </div>
        
        <div style="position: relative; margin-bottom: 1.5rem;">
          <input type="password" id="mgp-access-input" placeholder="CONTRASEÑA" style="width: 100%; padding: 15px 20px; background: #f9f9f9; border: 1px solid #ddd; border-radius: 0; color: #000; outline: none; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); font-size: 14px; letter-spacing: 2px; text-align: center;">
        </div>
        
        <button id="mgp-access-btn" style="width: 100%; padding: 16px; background: #000; color: #fff; border: none; border-radius: 0; font-weight: 800; cursor: pointer; transition: all 0.3s; font-size: 13px; letter-spacing: 2px; text-transform: uppercase;">
          ENTRAR
        </button>
        
        <p id="mgp-error-msg" style="color: #e10600; margin-top: 1.5rem; font-size: 0.75rem; display: none; letter-spacing: 1px; font-weight: 600;">ACCESO DENEGADO - CLAVE INCORRECTA</p>
        
        <div style="margin-top: 3rem; border-top: 1px solid #eee; padding-top: 2rem;">
          <a href="/" style="color: #999; text-decoration: none; font-size: 0.7rem; letter-spacing: 1.5px; text-transform: uppercase; transition: color 0.3s;">Volver al Inicio</a>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const input = document.getElementById('mgp-access-input');
    const btn = document.getElementById('mgp-access-btn');
    const error = document.getElementById('mgp-error-msg');

    input.focus();

    // Visual effect on focus
    input.addEventListener('focus', () => {
      input.style.borderColor = '#000';
      input.style.background = '#fff';
      input.style.color = '#000';
    });
    input.addEventListener('blur', () => {
      input.style.borderColor = '#ddd';
      input.style.background = '#f9f9f9';
      input.style.color = '#000';
    });

    function validate() {
      if (input.value === PASSWORD_SECRET) {
        const session = {
          granted: true,
          timestamp: new Date().getTime()
        };
        localStorage.setItem('mgp_access_session', JSON.stringify(session));
        location.reload(); 
      } else {
        error.style.display = 'block';
        input.style.borderColor = '#e10600';
        input.value = '';
        input.classList.add('shake');
        setTimeout(() => input.classList.remove('shake'), 500);
        input.focus();
      }
    }

    btn.addEventListener('click', validate);
    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') validate();
    });
  }

  // Execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAccess);
  } else {
    checkAccess();
  }
})();
